import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const ExclusionRatio = () => {
  const formBag = useFormContext();

  const { watch } = formBag;

  const annuityStartYear = watch('bankAccount.AnnuitizationStartYear');
  const annuityAtRetirement = watch('bankAccount.AnnuitizationStartAtRetirement');

  if (!annuityStartYear && !annuityAtRetirement) {
    return null;
  }

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.ExclusionRatio"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Exclusion Ratio"
          tooltip="Enter the exclusion ratio as a percentage (0-100%). This represents the portion of annuity payments that will not be subject to tax, as it reflects the return of the original investment (basis). If no exclusion ratio is entered, the cost basis will be used to determine the appropriate exclusion ratio."
          maxLength={3}
        />
      )}
    />
  );
};
